module.exports = __webpack_public_path__ + "img/defaultAvatar.678a1840.png";